import {useState, useEffect} from "react";
import axios from "axios";
import {Link, redirect, useLoaderData, useNavigate} from "react-router-dom";
import {faCaretDown, faCaretUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library as fontAwesomeLibrary} from "@fortawesome/fontawesome-svg-core";
import {Header} from "../layout/header.js";
import {Footer} from "../layout/footer.js";
import {SearchBar} from "../components/searchbar.js";
import {SearchResultsFacet} from "../components/searchresultsfacet.js";
import {SearchResultsTable} from "../components/searchresultstable.js";
import {parseFacetRestricts} from "./searchpage_utils.js";
import landingPageBg from "../images/landingpage-bg.png";
import {ExpandableText} from "../components/expandabletext.js";
import hdsSkrimImg from "../images/hds-skrim.png";

fontAwesomeLibrary.add(faCaretDown);
fontAwesomeLibrary.add(faCaretUp);


/**
 * React-router-dom Loader function to load backend endpoint with
 * AJAX, the response from which drives the page.
 *
 * @param params Parameters of the page URL
 */
export async function loader({request, params}) {
  const url = new URL(request.url);
  const searchParams = url.searchParams;
  let pageNum = parseInt(params.pageNum);
  if (isNaN(pageNum)) {
    pageNum = 1;
  }

  try {
      const requestStart = Date.now();
      let rawFacetRestricts = params.rawFacetRestricts || "";
      let sort = params.sort || "";
      let order = params.order || "";
      const nominal_start_time_from = searchParams.get("nominal_start_time_from");
      const nominal_start_time_to = searchParams.get("nominal_start_time_to");
      const nominal_start_time_ranges = searchParams.get("nominal_start_time_ranges");
      let effectiveQuery = params.query;
      let effectiveQuickSearchRestricts = [];
      let isTest = effectiveQuery.startsWith("{TEST}") || effectiveQuery.endsWith("{TEST}");

      //Set sort order for all datasets request
      if(params.query === "*") {
          sort="nominal_start_time";
          order="desc";
      }

      //Extract quick search fields
      let quickSearchRestricts = params.query
                                       .match(/(\w+):"([^"]*)"/g)
                                       ?.map(pair => {
                                           const [, key, value] = pair.match(/(\w+):"([^"]*)"/);
                                           if(['authors', 'doi', 'description', 'title', 'cadence_cat', 'variables',
                                               'variable_shortnames', 'instrument_id', 'has_ftp','has_api',
                                               'has_https','has_heliocloud_s3' ].includes(key.toLowerCase()))
                                           {
                                               effectiveQuickSearchRestricts.push(`${key}:"${value}"`);
                                               return null;
                                           } else{
                                               return `${(key).toLowerCase()}:=${value}`;
                                           }
                                       })
                                       .filter(Boolean)
                                       .join("&");

      if (quickSearchRestricts) {
          quickSearchRestricts = quickSearchRestricts.replace("mission:", "mission_facet_cs")
                              .replace("instrument:", "instrument_facet_cs")
                              .replace("cadence_cat:", "cadence_cat")
                              .replace("region:", "region")
                              .replace("has_api:", "has_api")
                              .replace("has_ftp:", "has_ftp")
                              .replace("has_heliocloud_s3:", "has_heliocloud_s3")
                              .replace("has_https:", "has_https");

         if(rawFacetRestricts === "") {
             rawFacetRestricts = quickSearchRestricts;
         } else if (rawFacetRestricts !== quickSearchRestricts ){
             const allowedKeys = new Set([
               "mission",
               //"instrument",
               "cadence_cat",
               "region",
               "has_api",
               "has_ftp",
               "has_heliocloud_s3",
               "has_https"
             ]);

             const reverseKeyMap = {
               mission_facet_cs: "mission",
               //instrument_facet_cs: "instrument",
               cadence_cat: "cadence_cat",
               region: "region",
               has_api: "has_api",
               has_ftp: "has_ftp",
               has_heliocloud_s3: "has_heliocloud_s3",
               has_https: "has_https"
             };

             const facetParams = new URLSearchParams(rawFacetRestricts);
             const queryParts = [];

             facetParams.forEach((value, key) => {
               const queryKey = reverseKeyMap[key];
               if (queryKey && allowedKeys.has(queryKey)) {
                 queryParts.push(`${queryKey}:"${value}"`);
               }
             });

             effectiveQuery = isTest ? "{TEST}": "";
effectiveQuery = [
    ...queryParts,                       // ['mission:"THEMIS"']
    ...effectiveQuickSearchRestricts,    // ['instrument_id:"THEMIS_D_EFI"', 'authors:"Ergun"']
].join(" ");
            // effectiveQuery = effectiveQuery + queryParts.join(" ") + effectiveQuickSearchRestricts.join('&');

         }
      }

      const response = await axios.get(
          `/heliodata/app/load_search_page/${pageNum}?q=${encodeURIComponent(effectiveQuery)}&` +
                          (sort ? `sort=${encodeURIComponent(sort)}&` : "") +
                          (order ? `order=${encodeURIComponent(order)}&` : "") +
                          (nominal_start_time_from ? `nominal_start_time_from=${encodeURIComponent(nominal_start_time_from)}&` : "") +
                          (nominal_start_time_to ? `nominal_start_time_to=${encodeURIComponent(nominal_start_time_to)}&` : "") +
                          (nominal_start_time_ranges ? `nominal_start_time_ranges=${encodeURIComponent(nominal_start_time_ranges)}&` : "") +
                          `${rawFacetRestricts}`
      );
      const requestTimeToComplete = (Date.now() - requestStart) / 1000;

      let unfilteredResponse = null;
      let unfilteredMissionOnlyResponse = null;

      if(rawFacetRestricts !== "") {
          const onlyMission = rawFacetRestricts
              .split("&")
              .filter(param => param.startsWith("mission_facet_cs="))
              .join("&");

          unfilteredResponse = await axios.get(
              `/heliodata/app/load_search_page/${encodeURIComponent(params.pageNum)}?q=${encodeURIComponent("{REPEAT}" + effectiveQuery)}&` +
              (sort ? `sort=${encodeURIComponent(sort)}&` : "") +
              (order ? `order=${encodeURIComponent(order)}&` : "") +
              (nominal_start_time_from ? `nominal_start_time_from=${encodeURIComponent(nominal_start_time_from)}&` : "") +
              (nominal_start_time_to ? `nominal_start_time_to=${encodeURIComponent(nominal_start_time_to)}&` : "") +
              ``
          );

          if(onlyMission || onlyMission !== ""){
              unfilteredMissionOnlyResponse = await axios.get(
                  `/heliodata/app/load_search_page/${encodeURIComponent(params.pageNum)}?q=${encodeURIComponent("{REPEAT}" + effectiveQuery)}&` +
                  (sort ? `sort=${encodeURIComponent(sort)}&` : "") +
                  (order ? `order=${encodeURIComponent(order)}&` : "") +
                  (nominal_start_time_from ? `nominal_start_time_from=${encodeURIComponent(nominal_start_time_from)}&` : "") +
                  (nominal_start_time_to ? `nominal_start_time_to=${encodeURIComponent(nominal_start_time_to)}&` : "") +
                  `${onlyMission}`
              );
          }
      }

      return {
          searchData: response.data,
          unfilteredSearchData: {...(unfilteredResponse?.data)},
          unfilteredMissionOnlySearchData: {...(unfilteredMissionOnlyResponse?.data)},
          query: params.query,
          requestTimeToComplete,
          rawFacetRestricts: rawFacetRestricts,
          pageNum: pageNum,
          sort: sort,
          order: order,
      };
  }
  catch (error) {
      /* todo: make custom dataset missing page */
      console.log(`Encountered an Error! ${error}`);
      return redirect("/error");
  }
}


/**
 * React component to display the dataset page.
 */
export function SearchPageContent() {
    const {searchData, unfilteredSearchData, unfilteredMissionOnlySearchData, query, rawFacetRestricts, requestTimeToComplete, pageNum, sort, order} = useLoaderData();
    const navigate = useNavigate();
    const [currentQuery, setCurrentQuery] = useState("");

    const facetFields = ["instrument_facet_cs", "measurement_type_cs", "eras", "cadence_cat", "region"];
    const allFacetsValuesArr = {};

    facetFields.map((val)=>{
        allFacetsValuesArr[val] = null
    })

    const [allFacetFieldOptions, setAllFacetFieldOptions] = useState(allFacetsValuesArr);
    const [selectedMissions, setSelectedMissions] = useState();

    const [dateRange, setDateRange] = useState(null);

    const facetRestricts = parseFacetRestricts(rawFacetRestricts);
    const facetRestrictsPillList = [];


    useEffect(() => {

        //Set facet_values are should be display regardless if it is selected or not
        facetFields.map((val, i) => {
            const params = new URLSearchParams(rawFacetRestricts);
            const missions = params.get("mission_facet_cs");
            setSelectedMissions(missions);

            if (!rawFacetRestricts.includes(val)) {
                // Example instrument_facet_cs = ['IBEX-Hi', 79, 'BARREL Balloos', 52, 'MMS FIELDS/EDI', 32, "PSP FIELDS", 0]
                let filteredFacetValues = null

                if(unfilteredSearchData?.facets)
                {
                    filteredFacetValues = searchData?.facets?.facet_fields[val]?.filter((item, index, array) => {
                    // Keep the item if the next element is not 0
                        return item !== 0 && array[index + 1] !== 0;
                    });
                } else {
                    filteredFacetValues = unfilteredSearchData?.facets?.facet_fields[val]?.filter((item, index, array) => {
                    // Keep the item if the next element is not 0
                        return item !== 0 && array[index + 1] !== 0;
                    });
                }

                setAllFacetFieldOptions(prev => ({
                    ...prev,
                    [val]: filteredFacetValues
                }));
            } else if (rawFacetRestricts.includes(val) && !rawFacetRestricts.includes("mission_facet_cs")) {

                if(rawFacetRestricts.split('&').length === 1){
                    setAllFacetFieldOptions(prev => ({
                        ...prev,
                        [val]: unfilteredSearchData?.facets?.facet_fields[val]
                    }));
                } else {
                    setAllFacetFieldOptions(prev => ({
                        ...prev,
                        [val]: searchData?.facets?.facet_fields[val]
                    }));
                }
            }else if (rawFacetRestricts.includes(val) && rawFacetRestricts.includes("mission_facet_cs")) {

                    let filteredFacetValues = null

                if(rawFacetRestricts.split('&').length === 2) {
                    filteredFacetValues = unfilteredMissionOnlySearchData?.facets?.facet_fields[val]?.filter((item, index, array) => {
                        return item !== 0 && array[index + 1] !== 0;
                    });
                }else {
                    filteredFacetValues = searchData?.facets?.facet_fields[val]?.filter((item, index, array) => {                                                      return item !== 0 && array[index + 1] !== 0;
                    });
                }

                setAllFacetFieldOptions(prev => ({
                    ...prev,
                    [val]: filteredFacetValues
                }));
            }
        })
    }, [rawFacetRestricts, unfilteredSearchData]);

    return (
        <div>
          <Header scrollToTop={true} hideSearch={true} />
          <div
            className="searchPageBanner"
            style={{backgroundImage: `url(${hdsSkrimImg}), url(${landingPageBg})`}}>

            <div className="searchPageTitle">
              Data Search
            </div>

            <div className="searchBarContainer">
              <SearchBar
                currentQuery={currentQuery}
                setCurrentQuery={setCurrentQuery}
                navigate={navigate}
                isNonLandingPageBar={true} />
            </div>
          </div>

          <div className="genericBody">

            <div className="searchResultsBodyContainer">
              <div className="searchResultsBodyLeft">
                <SearchResultsFacet
                  query={query}
                  facetData={searchData.facets}
                  defaultFacetData={unfilteredSearchData?.facets}
                  instruments={allFacetFieldOptions["instrument_facet_cs"]}
                  measurements={allFacetFieldOptions["measurement_type_cs"]}
                  eras={allFacetFieldOptions["eras"]}
                  timeResolutions={allFacetFieldOptions["cadence_cat"]}
                  regions={allFacetFieldOptions["region"]}
                  originalQuery={query}
                  facetRestricts={facetRestricts}
                  numFound={searchData.numFound}
                  navigate={navigate}
                  setDateRange={setDateRange}
                  getNavigateUrl={(newQueryString, newParams )=>
                                  `/search/${query}/1/${newQueryString}${newParams ? "?" + newParams : ""}`}
                  regionTaxonomyTitles={searchData.regionTaxonomyTitles}
                />
              </div>
              <div className="searchResultsBodyRight">

                {searchData.missionInfoBox && searchData.missionInfoBox.length > 0
                 && <MissionInfoBox missionData={searchData.missionInfoBox} />}

                {searchData.serviceInfoBox && searchData.serviceInfoBox.length > 0
                 && <ServiceInfoBox serviceData={searchData.serviceInfoBox} />}

                <SearchResultsTable
                  key={currentQuery}
                  searchData={searchData}
                  query={query}
                  rawFacetRestricts={rawFacetRestricts}
                  url={`/heliodata/app/load_search_page`}
                  pageNum={pageNum}
                  defaultSort={sort}
                  defaultOrder={order}
                  dateRange={dateRange}
                  requestTimeToComplete={requestTimeToComplete}
                  missionId= {null} />
              </div>
            </div>
          </div>
          <Footer />
        </div>
    );
}


/**
 * Displays an info box at the top of the search results page that shows related mission
 * information.
 * @param prop.missionData Object describing the mission to display.
 */
function MissionInfoBox(props) {
    const {missionData} = props;
    const [hideThumbnail, setHideThumbnail] = useState(false);
    const [expandRelated, setExpandRelated] = useState(false);
    const imageUrl = `/heliodata/app/load_mission_image/${missionData[0].hcutId}`;

    const relatedMissions = missionData.slice(1);
    const relatedShowCount = 4;
    const relatedNeedsTruncate = relatedMissions.length > relatedShowCount;
    const visibleRelated = relatedNeedsTruncate && !expandRelated
        ? relatedMissions.slice(0, relatedShowCount)
        : relatedMissions;
    const expandLinkStyle = {color: "#2290BF", cursor: "pointer"};
    const multiLongName = missionData.filter((m) => m.longName === missionData[0].longName).length > 1;
    const isDifferentShortName = missionData[0].longName !== missionData[0].shortName;
    const hideShortName = missionData[0].hideShortName;

    return (
        <div className="search-page-supp-info-outer">
          <div className="search-page-supp-info-inner">

            <div className="search-page-supp-info-body">
              <div>
                <div>
                  <br/>
                  <span className="search-page-supp-info-pill">
                    Mission or Observatory
                  </span>
                </div>
                <br />
                <div>
                <Link to={`/mission/${missionData[0].hcutId}`}>
                  <strong>{missionData[0].longName}
                          {((!hideShortName && isDifferentShortName) || multiLongName) && " ("}
                          {(!hideShortName && isDifferentShortName) && `${missionData[0].shortName}`}
                          {(isDifferentShortName && multiLongName) && " "}
                          {multiLongName && `${missionData[0].hcutId?.split("_")[0]}`}
                          {((!hideShortName && isDifferentShortName) || multiLongName) && ")"}
                  </strong>
                </Link></div>

                <ExpandableText
                  text={missionData[0].description}
                  showWordCount={60}
                  showLineCount={6} />
              </div>

              <Link to={`/mission/${missionData[0].hcutId}`}>
                <br/>
                <img
                  src={imageUrl}
                  className="search-page-mission-info-box-thumbnail"
                  alt="Mission Thumbnail"
                  style={{display: hideThumbnail ? "none" : ""}}
                  onError={() => setHideThumbnail(true)}
                />
              </Link>
            </div>
            {missionData.length > 1 && (
              <div>
              <br />
                <div className="search-page-mission-info-box-multi-version-mission">
                  {visibleRelated.map((mission) => (
                    <div key={mission.hcutId} className="search-page-mission-info-box-mission-version">
                      <a href={`/mission/${mission.hcutId}`}>
                        {mission.longName}
                        {missionData.filter((m) => m.longName === mission.longName).length > 1 && ` (${mission.hcutId?.split("_")[0]})`}
                      </a>
                    </div>))
                  }
                  {relatedNeedsTruncate && !expandRelated && (
                    <span
                      onClick={() => setExpandRelated(true)}
                      style={expandLinkStyle}>
                      <FontAwesomeIcon icon={faCaretDown} />
                      &nbsp;
                      See More
                    </span>
                  )}
                  {relatedNeedsTruncate && expandRelated && (
                    <span
                      onClick={() => setExpandRelated(false)}
                      style={expandLinkStyle}>
                      <FontAwesomeIcon icon={faCaretUp} />
                      &nbsp;
                      See Less
                    </span>
                  )}
                </div>
              </div>)
            }
          </div>
        </div>
    );
}


/**
 * Displays an info box at the top of the search results page that shows related service
 * information.
 * @param prop.serviceData Object describing the service to display.
 */
function ServiceInfoBox(props) {
    const {serviceData} = props;
    const [hideThumbnail, setHideThumbnail] = useState(false);
    const [expandRelated, setExpandRelated] = useState(false);
    const imageUrl = `/heliodata/app/load_service_image/eclipse`;

    const relatedServices = serviceData.slice(1);
    const relatedShowCount = 4;
    const relatedNeedsTruncate = relatedServices.length > relatedShowCount;


    return (
        <div className="search-page-supp-info-outer">
          <div className="search-page-supp-info-inner">
            <div className="search-page-supp-info-body">
              <div>
                <div>
                  <br/>
                  <span className="search-page-supp-info-pill">
                    Service
                  </span>
                </div>
                <br />
                <div>
                    <strong>
                      {serviceData[0].shortName}
                    </strong>
                </div>

                <ExpandableText
                  text={serviceData[0].description}
                  showWordCount={60}
                  showLineCount={6} />
                <br/>
                {serviceData[0]?.urlInfo?.map((item, index) => (
                  <Link
                    key={index}
                    to={item?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <strong>{item?.name}</strong>
                  </Link>
                ))}
              </div>

              <div>
                <Link
                  to={serviceData[0]?.urlInfo[0]?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <br/>
                  <img
                    src={imageUrl}
                    className="search-page-mission-info-box-thumbnail"
                    alt="ServiceThumbnail"
                    style={{display: hideThumbnail ? "none" : ""}}
                    onError={() => setHideThumbnail(true)}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
    );
}
